"use client";

import { ProyectosPropiosData, useProyectosPropiosData } from "@/hooks/useProyectosPropiosData";
import React, { createContext, useContext, type ReactNode } from "react";


const ProyectosPropiosContext = createContext<ProyectosPropiosData | undefined>(undefined);

export const useProyectosPropios = () => {
  const ctx = useContext(ProyectosPropiosContext);

  if (!ctx) {
    throw new Error(
      "useProyectosPropios must be used within a ProyectosPropiosProvider"
    );
  }

  return ctx;
};

export function ProyectosPropiosProvider({
  children,
}: {
  children: ReactNode;
}) {
  const value = useProyectosPropiosData();

  return (
    <ProyectosPropiosContext.Provider value={value}>
      {children}
    </ProyectosPropiosContext.Provider>
  );
}